import { Tabs } from "antd";
import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const { TabPane } = Tabs;

export const VAT_TABS = {
  VAT: {
    key: "VAT",
    path: "/vat-view",
  },
  ELSTER: {
    key: "ELSTER",
    path: "/elster-view",
  },
};

const SubNavigation = ({ activeTab }: { activeTab: string }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const onChangeTab = useCallback(
    (key: string) => {
      if (key === VAT_TABS.VAT.key) {
        navigate(VAT_TABS.VAT.path + location.search);
      } else {
        navigate(VAT_TABS.ELSTER.path + location.search);
      }
    },
    [navigate, location.search]
  );

  return (
    <Tabs type="card" activeKey={activeTab} onChange={onChangeTab}>
      <TabPane tab={VAT_TABS.VAT.key} key={VAT_TABS.VAT.key} />
      <TabPane tab={VAT_TABS.ELSTER.key} key={VAT_TABS.ELSTER.key} />
    </Tabs>
  );
};

export default SubNavigation;
